import { render, staticRenderFns } from "./BannerService.vue?vue&type=template&id=083f8599&scoped=true&"
import script from "./BannerService.vue?vue&type=script&lang=js&"
export * from "./BannerService.vue?vue&type=script&lang=js&"
import style0 from "./BannerService.vue?vue&type=style&index=0&id=083f8599&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083f8599",
  null
  
)

export default component.exports